import { render } from "./FacultyHome.vue?vue&type=template&id=13f32aa8&scoped=true"
import script from "./FacultyHome.vue?vue&type=script&lang=js"
export * from "./FacultyHome.vue?vue&type=script&lang=js"

import "./FacultyHome.vue?vue&type=style&index=0&id=13f32aa8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f32aa8"]])

export default __exports__